import { useState, useEffect } from 'react';
import { Card, Grid, Stack, TextField, Typography, MenuItem, Box } from '@mui/material';
import _ from 'lodash';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { DatePicker } from '@mui/x-date-pickers';
import { useSelector } from 'react-redux';
import { UploadSingleFile } from 'components/upload';
import { useSnackbar } from 'notistack';

const validationSchema = Yup.object().shape({
  nameSalutation: Yup.string().required('Please select salutation'),
  name: Yup.string().required('Requried'),
  designation: Yup.string().required('Requried'),
  employeeId: Yup.string().required('Requried'),
  email: Yup.string().required('Required').email('Please enter valid email'),
  phoneNumber: Yup.string().required('Phone  is a required field').length(10, 'Please enter a valid Phone Number'),
  secondaryPhoneNumber: Yup.string().length(10, 'Please enter a valid Phone Number'),
  emergencyDetailsPrimaryName: Yup.string().required('Requried'),
  emergencyDetailsPrimaryPhoneNumber: Yup.string()
    .required('Phone  is a required field')
    .length(10, 'Please enter a valid Phone Number')
});

const nameSalOpts = [
  {
    label: 'Mr',
    value: 'mr'
  },
  {
    label: 'Mrs',
    value: 'mrs'
  },
  {
    label: 'M/s',
    value: 'm/s'
  }
];

export default function EmployeeForm(props) {
  const { formRef, docs, setDocs, isEdit, employeeIdError, setEmployeeIdError, setLoading } = props;
  const { spEmployeeDetail = {} } = useSelector(({ spEmployeeReducer }) => spEmployeeReducer);
  const [formData, setFormData] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    setFormData(spEmployeeDetail);
    setDocs({
      profile: { file: { preview: spEmployeeDetail?.profileImageUrl } }
    });
  }, [spEmployeeDetail]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      nameSalutation: '',
      name: '',
      designation: '',
      employeeId: '',
      email: '',
      address: '',
      ...formData,
      phoneNumber: formData?.phoneNumber?.primary || '',
      secondaryPhoneNumber: formData?.phoneNumber?.secondary || '',
      emergencyDetailsPrimaryName: formData?.emergencyDetails?.primary?.name || '',
      emergencyDetailsPrimaryPhoneNumber: formData?.emergencyDetails?.primary?.phoneNumber || '',
      emergencyDetailsSecondaryName: formData?.emergencyDetails?.secondary?.name || '',
      emergencyDetailsSecondaryPhoneNumber: formData?.emergencyDetails?.secondary?.phoneNumber || '',
      dateOfBirth: formData?.dateOfBirth || null
    },
    onSubmit: (e) => {},
    validationSchema
  });
  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;
  formRef.current = formik;

  const handleDrop = (acceptedFiles, fileName) => {
    console.log(acceptedFiles, 'fwfds');
    console.log(acceptedFiles[0], 'fwewewfds');
    console.log(fileName, 'ffwwfds');
    const file = acceptedFiles[0];
    console.log(file, 'fds');
    if (file) {
      const filePath = file.name.split('.').pop();
      const name = `${fileName}.${filePath}`;
      const newFile = new File([file], name, { type: file.type });
      setDocs({
        ...docs,
        [fileName]: { file: { ...newFile, preview: URL.createObjectURL(newFile) }, uploadFile: newFile }
      });
    }
  };

  useEffect(() => {
    if (employeeIdError) {
      enqueueSnackbar('This employee id has already registered. Please change employee Id', { variant: 'info' });
      setLoading(false);
    }
  }, [employeeIdError]);

  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Card sx={{ p: 3 }}>
          <Typography sx={{ fontSize: '24px' }}>Basic Info</Typography>

          <Stack>
            <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ my: { sm: 0.5, lg: 0.5 } }}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  select
                  fullWidth
                  label="Name Salutation *"
                  name="nameSalutation"
                  value={values.nameSalutation}
                  {...getFieldProps('nameSalutation')}
                  error={Boolean(touched.nameSalutation && errors.nameSalutation)}
                  helperText={touched.nameSalutation && errors.nameSalutation}
                >
                  {_.map(nameSalOpts, (opt, ind) => (
                    <MenuItem value={opt.value} key={`nameSal-${ind}`}>
                      {opt.label}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  // type="number"
                  label="Employee's Name"
                  name="employeeName"
                  value={values.name}
                  {...getFieldProps('name')}
                  error={touched.name && errors.name}
                  helperText={touched.name && errors.name}
                />
              </Grid>
            </Grid>
            <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ my: { sm: 0.5, lg: 0.5 } }}>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Employee Id*"
                  name="employeeId"
                  disabled={isEdit}
                  value={values.employeeId}
                  {...getFieldProps('employeeId')}
                  error={Boolean(touched.employeeId && errors.employeeId) || employeeIdError}
                  helperText={touched.employeeId && errors.employeeId}
                  onChange={(event) => {
                    setEmployeeIdError(false);
                    const { value } = event?.target;
                    formik.setFieldValue('employeeId', value);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <TextField
                  fullWidth
                  label="Designation"
                  name="designation"
                  value={values.designation}
                  {...getFieldProps('designation')}
                  error={Boolean(touched.designation && errors.designation)}
                  helperText={touched.designation && errors.designation}
                />
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <DatePicker
                  label="Date of birth"
                  fullWidth
                  value={values.dateOfBirth}
                  inputFormat="dd/MM/yyyy"
                  onChange={(value) => setFieldValue('dateOfBirth', value)}
                  renderInput={(params) => <TextField {...params} fullWidth />}
                />
              </Grid>
            </Grid>
            <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ my: { sm: 0.5, lg: 0.5 } }}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  type="number"
                  fullWidth
                  label="Primary Phone Number"
                  name="phoneNumber"
                  value={values.phoneNumber}
                  inputProps={{
                    inputMode: 'numeric',
                    autoComplete: 'new-amigo-number',
                    pattern: '[0-9]{10}',
                    form: {
                      autoComplete: 'off'
                    },
                    maxLength: 10
                  }}
                  {...getFieldProps('phoneNumber')}
                  onChange={(event) => {
                    const { value } = event?.target;

                    if (value.length <= 10) {
                      formik.setFieldValue('phoneNumber', value);
                    }
                  }}
                  error={touched.phoneNumber && errors.phoneNumber}
                  helperText={touched.phoneNumber && errors.phoneNumber}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  type="number"
                  fullWidth
                  label="Secondary Phone Number"
                  name="secondaryPhoneNumber"
                  value={values.secondaryPhoneNumber}
                  inputProps={{
                    inputMode: 'numeric',
                    autoComplete: 'new-amigo-number',
                    pattern: '[0-9]{10}',
                    form: {
                      autoComplete: 'off'
                    },
                    maxLength: 10
                  }}
                  {...getFieldProps('secondaryPhoneNumber')}
                  onChange={(event) => {
                    const { value } = event?.target;

                    if (value.length <= 10) {
                      formik.setFieldValue('secondaryPhoneNumber', value);
                    }
                  }}
                  error={touched.secondaryPhoneNumber && errors.secondaryPhoneNumber}
                  helperText={touched.secondaryPhoneNumber && errors.secondaryPhoneNumber}
                />
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2} sx={{ my: { sm: 0.5, lg: 0.5 } }}>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  fullWidth
                  label="Email*"
                  name="email"
                  value={values.email}
                  {...getFieldProps('email')}
                  error={Boolean(touched.email && errors.email)}
                  helperText={touched.email && errors.email}
                />
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2} sx={{ my: { sm: 0.5, lg: 0.5 } }}>
              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  fullWidth
                  label="Address"
                  name="address"
                  value={values.address}
                  {...getFieldProps('address')}
                  error={touched.address && errors.address}
                  helperText={touched.address && errors.address}
                />
              </Grid>
            </Grid>
          </Stack>
        </Card>
        <Card sx={{ p: 3, mt: 2 }}>
          <Typography sx={{ fontSize: '24px' }}>Emergency Details</Typography>

          <Stack>
            <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ my: { sm: 0.5, lg: 0.5 } }}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Primary Name*"
                  name="emergencyDetailsPrimaryName"
                  value={values.emergencyDetailsPrimaryName}
                  {...getFieldProps('emergencyDetailsPrimaryName')}
                  error={touched.emergencyDetailsPrimaryName && errors.emergencyDetailsPrimaryName}
                  helperText={touched.emergencyDetailsPrimaryName && errors.emergencyDetailsPrimaryName}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  type="number"
                  fullWidth
                  label="Primary Phone Number*"
                  name="emergencyDetailsPrimaryPhoneNumber"
                  value={values.emergencyDetailsPrimaryPhoneNumber}
                  inputProps={{
                    inputMode: 'numeric',
                    autoComplete: 'new-amigo-number',
                    pattern: '[0-9]{10}',
                    form: {
                      autoComplete: 'off'
                    },
                    maxLength: 10
                  }}
                  {...getFieldProps('emergencyDetailsPrimaryPhoneNumber')}
                  onChange={(event) => {
                    const { value } = event?.target;

                    if (value.length <= 10) {
                      formik.setFieldValue('emergencyDetailsPrimaryPhoneNumber', value);
                    }
                  }}
                  error={touched.emergencyDetailsPrimaryPhoneNumber && errors.emergencyDetailsPrimaryPhoneNumber}
                  helperText={touched.emergencyDetailsPrimaryPhoneNumber && errors.emergencyDetailsPrimaryPhoneNumber}
                />
              </Grid>
            </Grid>
            <Grid container direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ my: { sm: 0.5, lg: 0.5 } }}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  label="Secondary Name"
                  name="emergencyDetailsSecondaryName"
                  value={values.emergencyDetailsSecondaryName}
                  {...getFieldProps('emergencyDetailsSecondaryName')}
                  error={Boolean(touched.emergencyDetailsSecondaryName && errors.emergencyDetailsSecondaryName)}
                  helperText={touched.emergencyDetailsSecondaryName && errors.emergencyDetailsSecondaryName}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  type="number"
                  fullWidth
                  label="Secondary Phone Number"
                  name="emergencyDetailsSecondaryPhoneNumber"
                  value={values.emergencyDetailsSecondaryPhoneNumber}
                  inputProps={{
                    inputMode: 'numeric',
                    autoComplete: 'new-amigo-number',
                    pattern: '[0-9]{10}',
                    form: {
                      autoComplete: 'off'
                    },
                    maxLength: 10
                  }}
                  {...getFieldProps('emergencyDetailsSecondaryPhoneNumber')}
                  onChange={(event) => {
                    const { value } = event?.target;

                    if (value.length <= 10) {
                      formik.setFieldValue('emergencyDetailsSecondaryPhoneNumber', value);
                    }
                  }}
                  error={Boolean(
                    touched.emergencyDetailsSecondaryPhoneNumber && errors.emergencyDetailsSecondaryPhoneNumber
                  )}
                  helperText={
                    touched.emergencyDetailsSecondaryPhoneNumber && errors.emergencyDetailsSecondaryPhoneNumber
                  }
                />
              </Grid>
            </Grid>
          </Stack>
        </Card>
        <Card sx={{ p: 3, mt: 2 }}>
          <Typography sx={{ fontSize: '24px' }}>Documents</Typography>
          <Stack spacing={3} sx={{ mt: 2 }}>
            <Box>
              <Typography sx={{ fontSize: '16px' }}>Employee`s Images</Typography>
              <Stack sx={{ display: 'flex', flexDirection: 'row', mt: 1 }}>
                <UploadSingleFile
                  maxSize={3145728}
                  accept="image/*"
                  file={docs.profile?.file}
                  onDrop={(accFile) => handleDrop(accFile, 'profile')}
                />
              </Stack>
            </Box>
          </Stack>
        </Card>
      </Form>
    </FormikProvider>
  );
}
